angular.module('myApp.services')
    .factory("audioSensitivity", ['audioVideoResponse', '$rootScope', function(audioVideoResponse, $rootScope) {
        var audioLevelMin               = 10;
        var startDoingCheckAfterSeconds = 3000; //ms
        var audioCheckStatus            = {};
        var init = function (qId) {
            if (!(qId in audioCheckStatus)) {
                audioCheckStatus[qId] = {
                    'status'    : false,
                    'isDoCheck' : true
                };
            }
        };
        var emitAudioCheckStatus = function (qId) {
            if (qId in audioCheckStatus) {
                $rootScope.$broadcast('audioCheckStatus', {'qId': qId, 'status': audioCheckStatus[qId].status});
            }
        };
        var statuses = {
            'ok'    :   2,
            'low'   :   1,
            'no'    :   0
        };
        return {
            checkCurrentAudioLevel: function(qId, level) {
                if (this.isDoAudioCheck(qId)) {
                    level = parseInt(level);
                    if (level <= audioLevelMin) {
                        audioCheckStatus[qId].status = statuses.no;
                    } else {
                        audioCheckStatus[qId].status = statuses.ok;
                    }
                    emitAudioCheckStatus(qId);
                }
            },
            getStartDoingCheckAfterSeconds: function () {
                return startDoingCheckAfterSeconds;
            },
            isDoAudioCheck: function (qId) {
                init(qId);
                return audioCheckStatus[qId].isDoCheck;
            },
            statuses: statuses
        }
    }]);